import React, { Component } from 'react'; 
import axios from 'axios';

const AddPropertyFormAction = async addProperty => {
  return await new Promise((resolve,reject) => {
    const fd = new FormData();
    fd.append('propetyName',addProperty.propetyName);
    fd.append('propertyType',addProperty.propertyType)
    fd.append('areaSqft',addProperty.areaSqft)
    fd.append('priceSqft',addProperty.priceSqft)
    fd.append('total',addProperty.total)
    fd.append('aboutProperty',addProperty.aboutProperty)
    fd.append('googleMap',addProperty.googleMap)
    fd.append('locationAddress',addProperty.locationAddress)
    fd.append('UdsValue',addProperty.UdsValue)
    fd.append('bedRoomNo',addProperty.bedRoomNo)
    fd.append('toiletNo',addProperty.toiletNo)
    fd.append('parkingNo',addProperty.parkingNo)
    fd.append('areaBuiltUp',addProperty.areaBuiltUp)
    fd.append('houseVillaNumber',addProperty.houseVillaNumber)
    fd.append('waterSupplyCapacity',addProperty.waterSupplyCapacity)
    fd.append('Sump',addProperty.Sump)
    fd.append('Oth',addProperty.Oth)
    fd.append('ResidentialType',addProperty.ResidentialType)
    fd.append('youtubeEmbededLink',addProperty.youtubeEmbededLink)
    fd.append('subLocation',addProperty.subLocation)

    if(addProperty.imageUploadList){
    const lenghtImage=addProperty.imageUploadList.length;
    for(var a=0;a<lenghtImage;a++){
      fd.append("myFile"+a, 
      addProperty.imageUploadList[a], 
      addProperty.imageUploadList[a].name);
      
  }
}
if(addProperty.uploadLogoFile){
  fd.append('uploadLogo', addProperty.uploadLogoFile, addProperty.uploadLogoFile.name);
}


    
    axios.post('https://internationalstrategicconsultants.com/iscPropExApi/add-Property-v1.php', fd
    ).then(res => {
        resolve(res);
        
      
      })
      .catch(error => {
            reject(error);
        }
        );
  })
  
}


export default AddPropertyFormAction;

